<fullscreen-page>
    <content-column look="dark">
        <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">

            <div class="d-flex flex-row flex-grow-1 overflow-hidden">

                <div class="flex-grow-1 h-100 overflow-auto p-3">

            <dx-data-grid
                id="gridContainer"
                #dataGrid
                class="h-100"
                [dataSource]="catalogs"
                [remoteOperations]="false"
                [allowColumnReordering]="true"
                [rowAlternationEnabled]="true"
                [allowColumnResizing]="true"
                [noDataText]="noDataText"
                [showBorders]="true"
                [hoverStateEnabled]="true"
                [focusedRowEnabled]="true"
                [focusedRowKey]="selectedCatalogId"
                keyExpr="id"
                (onFocusedRowChanged)="onFocusedRowChanged($event)"
                (onRowDblClick)="catalogSelected($event.data)"
                [columnMinWidth]="50"
            >
                <dxo-data-grid-column-chooser
                    height="340px"
                    [enabled]="true"
                    mode="select">
                    <dxo-data-grid-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"/>
                    <dxo-data-grid-search [enabled]="true"/>
                </dxo-data-grid-column-chooser>

                <dxo-data-grid-toolbar>
                    <dxi-data-grid-item location="before">
                        <dx-button
                            [visible]="canView('refreshButton')"
                            stylingMode="outlined"
                            type="default"
                            text="{{ 'Aktualisieren' | translate }}"
                            (onClick)="refresh()"
                            hint="{{ 'Katalogliste aktualisieren' | translate }}"
                        ></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item [visible]="catalogService.copyCatalogId != ''" location="before">
                        <dx-button
                            stylingMode="outlined"
                            type="default"
                            text="{{ 'Katalog einfügen' | translate }}"
                            (onClick)="pasteCatalog()"
                            hint="{{ 'Katalog einfügen' | translate }}"
                        ></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item location="after">
                        <dx-button
                            [visible]="canView('backupButton')"
                            stylingMode="outlined"
                            type="default"
                            text="{{ 'Backups' | translate }}"
                            (click)="showBackUp()"
                            hint="{{ 'Vorhandene Backups anzeigen' | translate }}"
                        ></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item name="columnChooserButton"/>
                    <dxi-data-grid-item name="searchPanel"/>
                </dxo-data-grid-toolbar>

                <dxo-state-storing
                    [enabled]="true"
                    type="localStorage"
                    storageKey="ExportStageListState"
                    [savingTimeout]="0"
                ></dxo-state-storing>

                <dxo-paging [enabled]="false"></dxo-paging>
                <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
                <dxo-search-panel
                    [visible]="true"
                    [highlightCaseSensitive]="true"
                    placeholder="{{ 'Kataloge suchen' | translate }}"
                ></dxo-search-panel>

                <dxi-column
                    dataField="catalogName"
                    caption="{{ 'Katalog' | translate }}"
                    cellTemplate="catalogNameTemplate"
                    [allowHiding]="false"
                ></dxi-column>
                <div *dxTemplate="let catalog of 'catalogNameTemplate'">
                    <dx-button
                        stylingMode="text"
                        (onClick)="catalogSelected(catalog.data)"
                        text="{{ catalog.data.catalogName }}"
                        type="default"
                        style="min-width: 32px"
                    ></dx-button>
                </div>

                <dxi-column dataField="supplier.supplierName" caption="{{ 'Lieferant' | translate }}"></dxi-column>

                <dxi-column dataField="buyer.buyerName" caption="{{ 'Käufer' | translate }}"></dxi-column>

                <dxi-column
                    dataField="responsible"
                    caption="{{ 'Verantwortlicher' | translate }}"
                    [allowEditing]="false"
                    cellTemplate="responsibleTemplate"
                ></dxi-column>
                <div *dxTemplate="let catalog of 'responsibleTemplate'">
                    <dx-autocomplete
                        class="dataGridAutocomplete"
                        [minSearchLength]="0"
                        [dataSource]="catalogService.responsibleList"
                        [showClearButton]="true"
                        [showDropDownButton]="true"
                        valueChangeEvent="blur"
                        (onValueChanged)="updateResponsible(catalog)"
                        [(value)]="catalog.data.responsible"
                        [readOnly]="!canEdit('verantwortlicher')"
                    ></dx-autocomplete>
                </div>

                <dxi-column dataField="note" caption="{{ 'Notiz' | translate }}" cellTemplate="noteTemplate"></dxi-column>
                <div *dxTemplate="let catalog of 'noteTemplate'">
                    <dx-text-box
                        [readOnly]="!canEdit('catalogNote')"
                        [(value)]="catalog.data.note"
                        [showClearButton]="false"
                        (onValueChanged)="update(catalog)"
                    ></dx-text-box>
                </div>

                <dxi-column dataField="catalogVersion" caption="{{ 'Version' | translate }}" [width]="80"></dxi-column>

                <dxi-column
                    dataField="language"
                    caption="{{ 'Sprache' | translate }}"
                    width="55"
                    cellTemplate="catalogLanguageTemplate"
                    *ngIf="loginService.hasAddonTranslate"
                ></dxi-column>
                <div *dxTemplate="let data of 'catalogLanguageTemplate'">
                    <img src="images/flags/{{ getLanguageFlag(data.data.language) }}" class="flag"/>
                </div>

                <dxi-column
                    dataField="date"
                    caption="{{ 'Datum' | translate }}"
                    dataType="date"
                    [format]="{ type: 'dd.MM.yyyy' }"
                    [width]="105"
                ></dxi-column>
                <dxi-column dataField="categoryCount" caption="{{ 'Kategorien' | translate }}" [width]="100"></dxi-column>
                <dxi-column dataField="productCount" caption="{{ 'Produkte' | translate }}" [width]="100"></dxi-column>
                <dxi-column
                    dataField="lastUpdate"
                    caption="{{ 'Änderung' | translate }}"
                    dataType="date"
                    [format]="{ type: 'dd.MM.yyyy' }"
                    [width]="105"
                ></dxi-column>
                <dxi-column
                    dataField="isPublic"
                    caption="{{ 'Öffentlich' | translate }}"
                    [width]="100"
                    cellTemplate="isPublicTemplate"
                ></dxi-column>
                <div *dxTemplate="let catalog of 'isPublicTemplate'">
                    <div *ngIf="!catalog.data.isVirtual">
                        <dx-switch
                            [readOnly]="!canEdit('isPublic')"
                            (onValueChanged)="update(catalog)"
                            [(value)]="catalog.data.isPublic"
                            switchedOffText="{{ 'Nein' | translate }}"
                            switchedOnText="{{ 'Ja' | translate }}"
                        ></dx-switch>
                    </div>
                </div>

                <dxi-column type="buttons" [allowHiding]="false" caption="{{ 'Aktionen' | translate }}">
                    <dxi-button text="{{ 'Katalog duplizieren' | translate }}"
                                icon="copy"
                                [onClick]="duplicateCatalog">
                    </dxi-button>
                    <dxi-button text="{{ 'Katalog kopieren' | translate }}"
                                icon="description"
                                [onClick]="copyCatalog">
                    </dxi-button>
                    <dxi-button text="{{ 'Wiederherstellungspunkt erstellen' | translate }}"
                                icon="clock"
                                [onClick]="createRestorePoint">
                    </dxi-button>
                    <dxi-button text="{{ 'Aus Exportstage entfernen' | translate }}"
                                icon="minus"
                                [onClick]="removeFromStage">
                    </dxi-button>
                    <dxi-button text="{{ 'Löschen' | translate }}"
                                icon="trash"
                                [onClick]="showDeleteDialog">
                    </dxi-button>
                </dxi-column>

            </dx-data-grid>
                </div>

                <np-inspect-panel
                    context="containerCatalog"
                    [catalogId]="selectedCatalogId"
                    [titleOverride]="selectedCatalogName"
                    [logoLink]="selectedCatalogLogo">
                </np-inspect-panel>

            </div>
        </div>
    </content-column>
</fullscreen-page>

<dx-popup
    title="{{ 'Datensicherungen' | translate }}"
    [width]="1000"
    [height]="800"
    [dragEnabled]="false"
    [showCloseButton]="true"
    [hideOnOutsideClick]="true"
    [(visible)]="backUpVisible"
    contentTemplate="popupContent">
    <div *dxTemplate="let data of 'popupContent'">
        <backup></backup>
    </div>
</dx-popup>
